// Task #3972 — The notification bell was mentions-only: the dashboard Team Inbox
// owns actionable assignment items (task / to-do / member-message assignments).
// PadSplit send-UX re-adds ONE actionable type — a terminally-failed outbound
// message — because a failed send must be unmissable for the operator who sent
// it. The allowed set lives in @shared/bell-notification-types so the bell list
// and its unread badge (server-side count) can never drift.
import { isBellNotificationType } from "@shared/bell-notification-types";

export interface BellNotificationLike {
  type: string;
}

export function bellNotifications<T extends BellNotificationLike>(list: readonly T[]): T[] {
  return list.filter((n) => isBellNotificationType(n.type));
}
